import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  slider: {
    width: '100% !important',
    marginTop: '20px',
    marginBottom: 'unset',
    '& .MuiSlider-markLabel': {
      top: '-16px',
      fontSize: theme.typography.caption.fontSize,
    },
    '& [data-index="0"].MuiSlider-markLabel': {
      left: '15px !important',
    },
    '& [data-index="1"].MuiSlider-markLabel': {
      right: '-80px !important',
    },
  },
}));

export default useStyles;
